import cronParser from "cron-parser";

/**
 * HCA Moravia — cron expression helpers pro scheduler (plán §S.2.9).
 *
 * Obal nad `cron-parser`. Žádný timezone handling — vše UTC. Toleruje
 * Vixie-style 5 polí (`min hour day-of-month month day-of-week`).
 */

/** Vrátí další běh podle cron expression, nebo null pokud je výraz neplatný. */
export function computeNextRun(expression: string, from: Date = new Date()): Date | null {
  if (expression.trim().length === 0) return null;
  try {
    const interval = cronParser.parseExpression(expression, { currentDate: from });
    return interval.next().toDate();
  } catch {
    return null;
  }
}

/** Rychlý validátor pro Zod refine. */
export function isValidCron(expression: string): boolean {
  if (expression.trim().length === 0) return false;
  try {
    cronParser.parseExpression(expression);
    return true;
  } catch {
    return false;
  }
}
